<template>
    <span class="loader"></span>
</template>

<script>
    export default {
        name: 'dotLoader'
    }
</script>

<style lang="scss">
.loader {
    z-index: 2;

    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: block;
    margin: 15px auto;
    color: var(--darkBlue) !important;
    box-sizing: border-box;
    animation: shadowRolling 2s linear infinite;
    top: 50%;
    left: 50%;
    position: fixed;
  }
  
  
  @keyframes shadowRolling {
    0% {
      box-shadow: 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
    }
    12% {
      box-shadow: 100px 0 var(--darkBlue), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
    }
    25% {
      box-shadow: 110px 0 var(--darkBlue), 100px 0 var(--darkBlue), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
    }
    36% {
      box-shadow: 120px 0 var(--darkBlue), 110px 0 var(--darkBlue), 100px 0 var(--darkBlue), 0px 0 rgba(255, 255, 255, 0);
    }
    50% {
      box-shadow: 130px 0 var(--darkBlue), 120px 0 var(--darkBlue), 110px 0 var(--darkBlue), 100px 0 var(--darkBlue);
    }
    62% {
      box-shadow: 200px 0 rgba(255, 255, 255, 0), 130px 0 var(--darkBlue), 120px 0 var(--darkBlue), 110px 0 var(--darkBlue);
    }
    75% {
      box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 130px 0 var(--darkBlue), 120px 0 var(--darkBlue);
    }
    87% {
      box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 130px 0 var(--darkBlue);
    }
    100% {
      box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0);
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/views/components/dotLoader.vue